'use client';

import dynamic from 'next/dynamic';
import type { ComponentProps, ComponentType } from 'react';
import type { PlayerResearchOverlay as ResearchOverlayComponent } from '@/components/client/research/PlayerResearchOverlay';
import type { LineMovementOverlay as LineOverlayComponent } from '@/components/client/LineMovementOverlay';

/**
 * Real product overlays, code-split so marketing visitors only pay for them on
 * interaction. Explicit ComponentType annotations because the overlays' prop
 * interfaces aren't exported — dynamic()'s inferred type would reference them (TS4023).
 */
export const PlayerResearchOverlay: ComponentType<
  ComponentProps<typeof ResearchOverlayComponent>
> = dynamic(
  () =>
    import('@/components/client/research/PlayerResearchOverlay').then((m) => ({
      default: m.PlayerResearchOverlay,
    })),
  { ssr: false },
);

export const prefetchResearchOverlay = () => {
  void import('@/components/client/research/PlayerResearchOverlay');
};

export const LineMovementOverlay: ComponentType<
  ComponentProps<typeof LineOverlayComponent>
> = dynamic(
  () =>
    import('@/components/client/LineMovementOverlay').then((m) => ({
      default: m.LineMovementOverlay,
    })),
  { ssr: false },
);

export const prefetchLineOverlay = () => {
  void import('@/components/client/LineMovementOverlay');
};
